<template>
    <span class="t-table-data">
        <slot :data="tableData" :array-get="arrayGet"></slot>
    </span>
</template>

<script>
import arrayGet from 'lodash/get';

export default {
    props: {
        for: {
            type: String,
            default: 'table',
        },
        path: {
            default: 'data',
        },
    },
    data() {
        return {
            tableData: null,
        };
    },
    created() {
        Bus.$on(`${this.for}TableLoaded`, this.tTableLoaded);
    },
    beforeDestroy() {
        Bus.$off(`${this.for}TableLoaded`, this.tTableLoaded);
    },
    methods: {
        arrayGet,
        tTableLoaded(payload) {
            this.tableData = payload;
        },
    },
};
</script>
